import { render, staticRenderFns } from "./RecoveryBonusPart.vue?vue&type=template&id=1b864736"
import script from "./RecoveryBonusPart.vue?vue&type=script&lang=js"
export * from "./RecoveryBonusPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports